import { useState, useEffect, useCallback } from 'react';
import newsService from '../services/newsService';
import { transformNewsData } from '../utils/newsTransformer';

const useNews = (category = null, page = 1) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNews = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      let response;
      
      if (category === null || category === 'all') {
        // Tüm haberler
        response = await newsService.getAllNews(page);
      } else {
        // Kategori bazlı haberler
        response = await newsService.getNewsListWithRetry(category, page);
      }
      
      if (response.success) {
        const transformedData = transformNewsData(response.data);
        setNews(transformedData);
      } else {
        setError('Haberler yüklenirken bir hata oluştu');
      }
    } catch (err) {
      setError(err.message || 'Beklenmeyen bir hata oluştu');
    } finally {
      setLoading(false);
    }
  }, [category, page]);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  const refetch = () => {
    fetchNews();
  };

  return { news, loading, error, refetch };
};

export default useNews;
